/**
 * ACCourseStatusService
 * Service for managing course statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for course status CRUD operations
 */
export class ACCourseStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ACCourseStatusService.DEFAULT_SERVICE_PATH,
            basePath: ACCourseStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ACCourseStatusService.DEFAULT_SERVICE_PATH = 'ac-courses';
ACCourseStatusService.BASE_PATH = 'api/course-statuses';
//# sourceMappingURL=ACCourseStatusService.js.map